import axios from "axios";
import {
  IVideosParams,
  IPostVideosParams,
  IPlayerAssetGetParams,
} from "Interfaces/AppInterface";
import { BASE_URL } from "App/constants";

export const getVideoConfig = async () => {
  const { data } = await axios.get(
    `${BASE_URL}assets/config`
    // `/mocks/assets.json?page=${currentPage}&source=${source}&per_page=${per_page}`
  );
  return data;
};

export const getAssetSignature = async (
  timestamp: number,
  public_id: string
) => {
  const { data } = await axios.post(`${BASE_URL}assets/signature`, {
    signature_params: {
      timestamp,
      public_id,
    },
  });
  return data;
};

export const getAssetList = async (param: IVideosParams) => {
  const { currentPage, per_page, upload_purpose } = param;
  let assetRequestURL = `${BASE_URL}assets?page=${currentPage}&per_page=${per_page}`;
  if (upload_purpose) {
    assetRequestURL = `${assetRequestURL}&upload_purpose=${upload_purpose}`;
  }
  const { data } = await axios.get(assetRequestURL);
  // const { data } = await axios.get(
  //   `/mocks/drills.json?page=${currentPage}&per_page=${per_page}`
  // );

  return data;
};

export const postVideoDetails = async (params: IPostVideosParams) => {
  const { data } = await axios.post(`${BASE_URL}assets`, params);
  // const { data } = await axios.get(
  //   `/mocks/assets.json?params=${JSON.stringify(param)}`
  // );
  return data;
};

export const deleteVideoDetails = async (id: number) => {
  const { data } = await axios.delete(`${BASE_URL}assets/${id}`);

  return data;
};

export const getVideoComments = async (asset_id: number) => {
  const { data } = await axios.get(
    // `${BASE_URL}assets/${asset_id}/comments`
    `/mocks/assetComments.json?`
  );

  return data;
};

export const getPlayerUploadedAssets = async (
  params: IPlayerAssetGetParams
) => {
  const { academy_id, player_id, page, per_page } = params;
  const { data } = await axios.get(
    `${BASE_URL}academies/${academy_id}/players/${player_id}/assets?page=${page}&per_page=${per_page}`
    // `/mocks/player_asset.json?params=${JSON.stringify(params)}`
  );

  return data;
};

export const downloadPlayerUploadedPdf = async (
  params: IPlayerAssetGetParams
) => {
  const { academy_id, player_id } = params;
  const { data } = await axios.get(
    `${BASE_URL}academies/${academy_id}/players/${player_id}/assets.pdf`,
    { responseType: "arraybuffer" }
    // `/mocks/player_asset.json?params=${JSON.stringify(params)}`
  );

  return data;
};
